import { gql } from "@apollo/client";
import {
  FRAGMENT_DASHBOARD_INFO_PARTS,
  FRAGMENT_INTEGRATIONS_SCREEN_PARTS,
} from "./fragment";

export const QUERY_COMPANY_MEMBERS_SCREEN = gql`
  query CompanyPortalMembersScreen(
    $appInfo: AppInfo!
    $searchQuery: String
    $statusSort: Boolean
    $itemsPerPage: Int
    $pageNumber: Int
  ) {
    companyPortalMembersScreen(
      appInfo: $appInfo
      searchQuery: $searchQuery
      statusSort: $statusSort
      itemsPerPage: $itemsPerPage
      pageNumber: $pageNumber
    ) {
      title
      subTitle
      searchQuery
      exampleCsv
      uploadButton {
        buttonText
        buttonStyle
        buttonAction
      }
      addButton {
        buttonText
        buttonStyle
        buttonAction
      }
      members {
        id
        member
        firstName
        lastName
        email
        timezone
        status
        statusDate
        action {
          buttonText
          buttonStyle
          buttonAction
        }
      }
      totalPages
      itemsPerPage
      pageNumber
      statusSort
      labels
    }
  }
`;

export const QUERY_COMPANY_ADMIN = gql`
  query companyAdmin($appInfo: AppInfo!) {
    companyAdmin(appInfo: $appInfo) {
      id
      firstName
      lastName
      fullName
      companyName
      photoUrl
      companyType
      companyId
    }
  }
`;

export const QUERY_COMPANY_INTEGRATIONS_SCREEN = gql`
  query CompanyPortalIntegrationsScreen($appInfo: AppInfo!) {
    companyPortalIntegrationsScreen(appInfo: $appInfo) {
      ...IntegrationsScreenParts
    }
  }

  ${FRAGMENT_INTEGRATIONS_SCREEN_PARTS}
`;

export const QUERY_COMPANY_ADMIN_SETTINGS_SCREEN = gql`
  query CompanyPortalAdminSettingsScreen($appInfo: AppInfo!) {
    companyPortalAdminSettingsScreen(appInfo: $appInfo) {
      title
      subTitle
      companyName
      admins {
        title: addButton {
          buttonAction
          buttonText
          buttonStyle
        }
        labels
        members {
          id
          member
          firstName
          lastName
          email
          timezone
          action {
            buttonAction
            buttonText
            buttonStyle
          }
        }
      }
      selectAdminList {
        id
        email
        firstName
        lastName
      }
    }
  }
`;

export const QUERY_ALL_COMPANY_MEMBERS = gql`
  query companyAdmin($appInfo: AppInfo!) {
    companyAdmin(appInfo: $appInfo) {
      membersScreen {
        members {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const QUERY_COMPANY_DASHBOARD_SCREEN = gql`
  query CompanyPortalDashboardScreen($appInfo: AppInfo!) {
    companyPortalDashboardScreen(appInfo: $appInfo) {
      ...dashboardInfoParts
    }
  }
  ${FRAGMENT_DASHBOARD_INFO_PARTS}
`;
